import { FILING_TABS } from '@constants/filing';
import { LOG_PAGE_TABS } from '@constants/logPage';
import { UUID_REGEX } from '@constants/routes';
import { generatePath } from '@helpers/route';

const path = '/vfile';
const FILING_PERIOD_ID = `:filingPeriodId(${UUID_REGEX})`;

export const vfileRoutes = {
  ROOT: {
    get rule() {
      return path;
    },
    get make() {
      return () => this.rule;
    },
  },
  FILING_LIST: {
    get rule() {
      return `${path}/filings/:deadlineType(due|preparing|filed)`;
    },
    get make() {
      return (deadlineType = 'due') => generatePath(this.rule, { deadlineType });
    },
  },
  FILING: {
    get rule() {
      return `${path}/filing/${FILING_PERIOD_ID}/:tab(${Object.values(FILING_TABS).join(
        '|'
      )})?/:subTab?`;
    },
    get make() {
      return (
        filingPeriodId: string,
        tab?: typeof FILING_TABS[keyof typeof FILING_TABS],
        subTab?: string
      ) => generatePath(this.rule, { filingPeriodId, tab, subTab });
    },
  },
  FILING_CREATE_MAPPING: {
    get rule() {
      return `${path}/filing/${FILING_PERIOD_ID}/mapping`;
    },
    get make() {
      return (filingPeriodId: string) => generatePath(this.rule, { filingPeriodId });
    },
  },
  FILING_PROCESSING: {
    get rule() {
      return `${path}/filing/${FILING_PERIOD_ID}/processing`;
    },
    get make() {
      return (filingPeriodId: string) => generatePath(this.rule, { filingPeriodId });
    },
  },
  FILING_SPREADSHEET: {
    get rule() {
      return `${path}/filing/${FILING_PERIOD_ID}/spreadsheet/:spreadsheetId?`;
    },
    get make() {
      return (filingPeriodId: string, spreadsheetId?: string) =>
        generatePath(this.rule, { filingPeriodId, spreadsheetId });
    },
  },
  FILING_TRANSACTIONS: {
    get rule() {
      return `${path}/filing/${FILING_PERIOD_ID}/transaction-data/:tab?`;
    },
    get make() {
      return (filingPeriodId: string, tab?: string) =>
        generatePath(this.rule, { filingPeriodId, tab });
    },
  },
  FILING_TROUBLESHOOT: {
    get rule() {
      return `${path}/filing/${FILING_PERIOD_ID}/troubleshoot/:aggregateId`;
    },
    get make() {
      return (filingPeriodId: string, aggregateId: string) =>
        generatePath(this.rule, { filingPeriodId, aggregateId });
    },
  },
  FILING_UPLOAD: {
    get rule() {
      return `${path}/filing/${FILING_PERIOD_ID}/upload/:type?`;
    },
    get make() {
      return (filingPeriodId: string, type?: string) =>
        generatePath(this.rule, { filingPeriodId, type });
    },
  },
  FILING_MASS_TROUBLESHOOT: {
    get rule() {
      return `${path}/filing/${FILING_PERIOD_ID}/troubleshoot`;
    },
    get make() {
      return (filingPeriodId: string) => generatePath(this.rule, { filingPeriodId });
    },
  },
  FILING_LOG_PAGE: {
    get rule() {
      return `${path}/filing/${FILING_PERIOD_ID}/log-page/:tab(${Object.values(LOG_PAGE_TABS).join(
        '|'
      )})`;
    },
    get make() {
      return (
        filingPeriodId: string,
        tab: typeof LOG_PAGE_TABS[keyof typeof LOG_PAGE_TABS] = LOG_PAGE_TABS.EDITED
      ) => generatePath(this.rule, { filingPeriodId, tab });
    },
  },
  GAME_CHANGER: {
    get rule() {
      return `${path}/game-changer/:entityId?`;
    },
    get make() {
      return (entityId?: string) => generatePath(this.rule, { entityId });
    },
  },
  GAME_CHANGER_DETAIL: {
    get rule() {
      return `${path}/filing/game-changer/:entityId/:templateId/:filingId/:name/:countryIso/:dateFilingDue/:mode?`;
    },
    get make() {
      return (
        entityId: string,
        templateId: string,
        filingId: string,
        name: string,
        countryIso: string,
        dateFilingDue: string,
        mode?: string
      ) =>
        generatePath(this.rule, {
          entityId,
          templateId,
          filingId,
          name,
          countryIso,
          dateFilingDue,
          mode,
        });
    },
  },
};
